module.exports = __webpack_public_path__ + "static/media/vail-5.00068c45.jpg";